import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import "./globals.css"

const isDev = (window as any).WP_COCKPIT?.devMode || false

if (isDev) {
  console.log('[KJ Cockpit] Script loaded!')
  console.log('[KJ Cockpit] React version:', React.version)
  console.log('[KJ Cockpit] Window object:', window)
}

// React initialization
const root = document.getElementById("cockpit-app-root");

// Attempt to detect the base pathname where the app is mounted.
// Prefer server-injected `WP_COCKPIT.assetsUrl` if available, otherwise derive from current script or location.
function detectBasePath(): string | undefined {
  const wp = (window as any).WP_COCKPIT

  // 1) If the server injected the explicit mountPath, use it. This is the most accurate.
  if (wp && wp.mountPath) {
    let p = String(wp.mountPath)
    if (!p.startsWith('/')) p = '/' + p
    // Normalize: remove trailing slash except when root
    if (p.length > 1) p = p.replace(/\/$/, '')
    return p
  }

  // 2) If WP_COCKPIT.assetsUrl is present, derive base by stripping known suffix
  if (wp && wp.assetsUrl) {
    try {
      const url = new URL(wp.assetsUrl, window.location.href)
      const pathname = url.pathname
      let base = pathname.replace(/\/dist\/assets\/?$/, '/')
      if (!base.startsWith('/')) base = '/' + base
      if (base.length > 1) base = base.replace(/\/$/, '')
      return base
    } catch (e) {
      // ignore parse errors for assetsUrl in production
    }
  }

  // 3) Last resort: use current location pathname (the page URL where the script runs)
  if (window.location && window.location.pathname) {
    let p = window.location.pathname
    if (!p.startsWith('/')) p = '/' + p
    if (p.length > 1) p = p.replace(/\/$/, '')
    return p
  }

  return undefined
}

const detectedBase = detectBasePath()

if (isDev) {
  console.log('[KJ Cockpit] Detected base path:', detectedBase)
  console.log('[KJ Cockpit] WP_COCKPIT:', (window as any).WP_COCKPIT)
  console.log('[KJ Cockpit] Root element:', root)
}

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <BrowserRouter basename={detectedBase}>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
} else {
  console.error('[KJ Cockpit] Root element #cockpit-app-root not found!')
}
